import React, { useState, useEffect } from "react";
import { Modal, Button, Input, Icon, Dropdown } from "semantic-ui-react";
import { useAuth } from "../../../../hooks";
import { getStaffApi } from "../../../../api/user";
import "./GuestsModal.scss";

const QUICK_COUNTS = Array.from({ length: 15 }, (_, i) => i + 1);

// "Selecciona la cantidad de personas" — mismo cuadro que Restaurant.pe al
// abrir una mesa del salón: botones 1–15 o escribir el número. Base del
// "ticket por persona" (afluencia) del Panel del día.
export function GuestsModal(props) {
  const { show, title = "Mesa", initialValue = null, initialWaiterId = null, onCancel, onConfirm } = props;
  const { auth } = useAuth();
  // El mesero que atiende ("Mesero: Carlos", como Restaurant.pe) es un USUARIO
  // existente, no texto libre (así no hay "Carlos"/"carlos" y la propina tiene
  // dueño). Arranca con quien tiene la sesión y se puede cambiar (un teléfono
  // compartido). Si alguien no aparece, el Admin crea primero su usuario.
  const [staff, setStaff] = useState([]);
  const [waiter, setWaiter] = useState(null);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setValue(initialValue ? String(initialValue) : "");
      setSaving(false);
      (async () => {
        try {
          const people = await getStaffApi(auth?.token);
          setStaff(people);
          const wanted = initialWaiterId || auth?.me?.id;
          setWaiter(people.some((person) => person.id === wanted) ? wanted : null);
        } catch (error) {
          setStaff([]);
          setWaiter(null);
        }
      })();
    }
  }, [show, initialValue, initialWaiterId]);

  const count = Number(value);
  const valid = Number.isInteger(count) && count >= 1 && count <= 200;

  const confirm = async () => {
    if (!valid) return;
    setSaving(true);
    try {
      await onConfirm(count, waiter);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={show} size="tiny" onClose={onCancel} className="guests-modal">
      <Modal.Content>
        <h3 className="guests-modal__title">{title}</h3>
        <p className="guests-modal__subtitle">Selecciona la cantidad de personas</p>
        <div className="guests-modal__grid">
          {QUICK_COUNTS.map((n) => (
            <button
              key={n}
              type="button"
              className={`guests-modal__count${count === n ? " guests-modal__count--active" : ""}`}
              onClick={() => setValue(String(n))}
            >
              {n}
            </button>
          ))}
        </div>
        <Input
          fluid
          type="number"
          min="1"
          placeholder="O escribe aquí el número de personas"
          value={value}
          onChange={(_, data) => setValue(data.value)}
          onKeyDown={(event) => event.key === "Enter" && confirm()}
        />
        <label className="guests-modal__waiter-label">Mesero que atiende</label>
        <Dropdown
          fluid
          selection
          search
          clearable
          className="guests-modal__waiter"
          placeholder="Escribe para buscar al mesero"
          options={staff.map((person) => ({ key: person.id, value: person.id, text: person.name }))}
          value={waiter}
          onChange={(_, data) => setWaiter(data.value === "" ? null : data.value)}
          noResultsMessage="Nadie con ese nombre: el administrador debe crear su usuario"
        />
        <p className="guests-modal__waiter-hint">
          Elige de la lista (escribe para buscarlo)
          {staff.length > 4 ? `: hay ${staff.length} personas, desliza para ver más` : ""}. Si no aparece, el
          administrador debe crear su usuario.
        </p>
      </Modal.Content>
      <div className="guests-modal__actions">
        <Button type="button" basic onClick={onCancel}>
          <Icon name="close" /> Cancelar
        </Button>
        <Button type="button" primary disabled={!valid || saving} loading={saving} onClick={confirm}>
          <Icon name="check" /> Continuar
        </Button>
      </div>
    </Modal>
  );
}
